import cryEmot from "../assets/cry.png";
import anonEmot from "../assets/anon.png";
import loveEmot from "../assets/love.png";
import fingerEmot from "../assets/finger.png";

const emoticons = [
	{ img: cryEmot, name: "cry" },
	{ img: anonEmot, name: "anon" },
	{ img: loveEmot, name: "love" },
	{ img: fingerEmot, name: "finger" }
];

export default emoticons;
